import Vue from "vue"
import Vuex from "vuex"
import { getField, updateField } from "vuex-map-fields"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    idToken : null,
    user: null,
    isAuthenticated: false,
    globalRefurbisher : null,
  },
  mutations: {
    updateField
  },
  getters: {
    getField
  }
})
